import React from 'react';
import { array, object, bool, func, string } from 'prop-types';

import { AssigneeItem } from './assignees-list-item';
import { AssigneesListWrapper } from './styled-components';


function AssigneesList({
  users,
  assignees,
  wrapperStyles,
  currentUserId,
  onRemoveAssignee,
  assigneeIconStyle,
  requestTasks,
  tasks,
}) {
  return (
    <AssigneesListWrapper
      wrapperStyles={wrapperStyles}
    >
      {assignees.map(userId => (
        <AssigneeItem
          users={users}
          key={`assignee-${userId}`}
          assignee={users[userId]}
          currentUserId={currentUserId}
          onRemoveAssignee={onRemoveAssignee}
          requestTasks={requestTasks}
          tasks={tasks}
          assigneeIconStyle={{
            ...assigneeIconStyle,
            ...(wrapperStyles && { marginBottom: '5px' }),
          }}
        />
      ))}
    </AssigneesListWrapper>
  );
}

AssigneesList.propTypes = {
  wrapperStyles: bool,
  currentUserId: string,
  onRemoveAssignee: func,
  assigneeIconStyle: object,
  users: object.isRequired,
  assignees: array.isRequired,
  requestTasks: array,
  tasks: object,
};

AssigneesList.defaultProps = {
  currentUserId: '',
  wrapperStyles: false,
  assigneeIconStyle: {},
  onRemoveAssignee: null,
  requestTasks: null,
  tasks: null,
};

export default AssigneesList;



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-header/request-assignees/assignees-list/index.js